﻿import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({ name: 'join' })
export class JoinPipe implements PipeTransform {
    transform(value, args: string): any {
        if (!value) return value;
        args = args || ', ';
        return value.join(args);
    }
}
